import { defaultCrossdockingId } from '@/shared/constants';
import { appLocalStorage } from './appLocalStorage';
/**
 * Gets current crossdockId from localStorage
 */
export function getCrossdockIdFromStorage() {
    const value = appLocalStorage.getItem('crossDockId');
    return value === null ? defaultCrossdockingId : Number(value);
}
